import React, { FC, ReactNode, useState } from "react";
import { StyledLabelWrapper, StyledContent } from "./index.styled";
import {
  CaretIconSvg,
  CaretPointDirections,
} from "../../../../components/icons";
import { colors } from "../../../../styles/variables";

export interface AccordionProps {
  children: ReactNode;
  isNested?: boolean;
  title: string;
}

export const Accordion: FC<AccordionProps> = ({
  children,
  isNested = false,
  title,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledLabelWrapper
        data-testid="accordion"
        onClick={() => {
          setOpen(!open);
        }}
      >
        {title}
        <CaretIconSvg
          pointDirection={
            open ? CaretPointDirections.up : CaretPointDirections.down
          }
          color={colors.gray600}
        />
      </StyledLabelWrapper>
      {open && <StyledContent isNested={isNested}>{children}</StyledContent>}
    </>
  );
};
